import { useQuery, skipToken } from "@tanstack/react-query";
import { SystemInputs } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
import i18n from "i18n";
const useInput = (inputId) => useQuery({
  queryKey: ["inputs", inputId],
  queryFn: inputId ? () => defaultOnError(
    SystemInputs.get(inputId),
    i18n.t("use_input_notifications.load_failed", { ns: "inputs" }),
    i18n.t("use_input_notifications.load_failed_title", { ns: "inputs" })
  ) : skipToken
});
export default useInput;
